import { getLocalStorageString } from "./localstorage";
const didHaveDebugParam = window?.location?.search?.indexOf("almad_debug=true") !== -1;
function inDebugMode() {
    return getLocalStorageString("almad_debug") === "true" || didHaveDebugParam;
}
// eslint-disable-next-line import/prefer-default-export
export { inDebugMode };
//# sourceMappingURL=debug.js.map